/**
 * Calculates the number of milliseconds that have ellapsed since the given time.
 * @param {number} time A time in milliseconds
 * @returns {number}
 */
export default function timeSince(time) {
    return Date.now() - time;
}